import { useState } from 'react';
import { UploadError } from '../../../components/Modal/ErrorDetailsModal/types';

export const useUploadErrors = () => {
  const [errors, setErrors] = useState<UploadError[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showErrors = (errorList: UploadError[]) => {
    setErrors(errorList);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return { errors, isModalOpen, showErrors, closeModal };
};
